export default "__VITE_ASSET__B0x2MwBo__"